<template>
  <div class="w-full text-left">
    <tutorial-button
      v-if="showBus == null"
      @click="
        showModal = true;
        page = 0;
      "
    />

    <modal v-if="showModal"
      ><modal-inner class="max-w-screen-lg self-center">
        <div
          class="pop-up-box-title flex justify-center flex-shrink-0 align-middle text-contrast-light content-center text-center"
        >
          <h2
            class="flex-grow text-chplus-title-tutorial font-bold uppercase self-center px-8"
          >
            <slot name="title"></slot>
          </h2>
          <div class="relative" v-if="showCloseButton">
            <button @click="close" class="absolute top-0 right-0">
              <icon-close class="text-3xl" />
            </button>
          </div>
        </div>

        <content-scroll-container
          class="tutorial-main-container flex-grow"
          :scroll="false"
        >
          <content-scroll-inner class="h-full" :flex="true">
            <p
              class="tutorial-box-desc text-chplus-regular flex flex-col justify-center text-center flex-shrink-0 content-center"
            >
              <slot name="text"></slot>
            </p>

            <div
              ref="tutorialImageBox"
              class="tutorial-image-box relative flex-1 flex flex-col justify-center"
            >
              <div
                ref="tutorialImage"
                class="tutorial-image absolute"
                style="top:50%;left:50%;transform: translate(-50%,-50%)"
              >
                <slot name="image" :page="page"></slot>
              </div>
            </div>
          </content-scroll-inner>
        </content-scroll-container>

        <div
          class="tutorial-bottom text-chplus-regular flex flex-col justify-center select-none"
        >
          <div class="flex flex-row">
            <div class="flex-1" style="margin-right: 3%">
              <navigate-small-button
                theme="border-interaction-dark"
                class="w-full"
                @click="page--"
                v-if="page > 0"
              >
                {{ $t("components.layouts.tutorial.button_back") }}
              </navigate-small-button>
            </div>
            <div class="flex-1">
              <navigate-small-button
                theme="border-interaction-dark"
                class="w-full"
                @click="page++"
                v-if="page < numPages - 1"
              >
                {{ $t("components.layouts.tutorial.button_next") }}
              </navigate-small-button>
              <navigate-small-button
                theme="contrast-light"
                class="w-full"
                @click="showModal = false"
                v-if="page == numPages - 1"
              >
                {{ $t("components.layouts.tutorial.button_complete") }}
              </navigate-small-button>
            </div>
          </div>
        </div>
      </modal-inner></modal
    >
  </div>
</template>

<script>
import IconClose from "@/components/icons/IconCircleReject";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import TutorialButton from "@/components/buttons/TutorialButton";
import Vue from "vue";
import Modal from "@/components/layouts/Modal";
import ModalInner from "@/components/layouts/ModalInner";
import NavigateSmallButton from "@/components/buttons/NavigateSmallButton";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";

// class="w-full h-full py-2 text-center text-interaction-dark bg-white border-2 border-interaction-dark rounded font-bold"
// class="w-full h-full py-2 text-center text-interaction-dark bg-white border-2 border-interaction-dark rounded font-bold"
// class="w-full h-full py-2 text-center text-white bg-contrast-light border-2 border-contrast-light rounded font-bold"

export default {
  name: "Tutorial",
  components: {
    ContentScrollInner,
    NavigateSmallButton,
    ModalInner,
    Modal,
    TutorialButton,
    ContentScrollContainer,
    IconClose
  },
  props: {
    showBus: {
      type: Vue,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    numPages: {
      type: Number,
      required: true
    },
    /**
     * Whether to show the info button on the right side of the screen instead of the left
     */
    attachRight: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      showModal: false,
      showCloseButton: false,
      page: 0
    };
  },
  created() {
    if (this.showBus != null) {
      this.showBus.$on("click", this.onShowClick);
    }
    this.showModal = this.show;
  },
  mounted() {
    this.onWindowResize();
    window.addEventListener("resize", this.onWindowResize);
  },
  destroyed() {
    if (this.showBus != null) {
      this.showBus.$off("click", this.onShowClick);
    }
    window.removeEventListener("resize", this.onWindowResize);
  },
  methods: {
    close() {
      this.showModal = false;
    },
    onShowClick() {
      this.showModal = true;
      this.showCloseButton = true;
      this.page = 0;
      setTimeout(() => this.onWindowResize(), 1);
    },
    onWindowResize() {
      if (!this.showModal) {
        return;
      }
      const tutorialImageBox = this.$refs["tutorialImageBox"];
      const tutorialImage = this.$refs["tutorialImage"];
      const boxStyle = getComputedStyle(tutorialImageBox);
      const width = parseInt(boxStyle.width);
      const height = parseInt(boxStyle.height);
      const size = Math.min(width, height);
      tutorialImage.style.width = size + "px";
      tutorialImage.style.height = size + "px";
    }
  }
};
</script>

<style lang="scss" scoped>
.pop-up-box-title {
  min-height: 4.312rem;
}
.tutorial-box-desc {
  min-height: 7.168rem;
}

.tutorial-bottom {
  min-height: 6.552rem;
}
.tutorial-image img {
  object-fit: contain;
}

@media (min-width: 768px) {
  .tutorial-box-desc {
    min-height: 8.448rem;
  }

  .tutorial-bottom {
    min-height: 7.68rem;
  }
}

@media (min-height: 1024px) {
  .pop-up-box-title {
    min-height: 5.12rem;
  }
}
</style>
